export default __webpack_public_path__ + "static/media/7-tuplu-dalis.e16b2125.jpg";